export enum ClientTeamMemberType {
    ADMIN = 'Client admin',
    COLLABORATOR = 'Client collaborator',
}
